import { render, staticRenderFns } from "./BookContentExtended.vue?vue&type=template&id=d7fe4748&scoped=true&"
import script from "./BookContentExtended.vue?vue&type=script&lang=js&"
export * from "./BookContentExtended.vue?vue&type=script&lang=js&"
import style0 from "./BookContentExtended.vue?vue&type=style&index=0&id=d7fe4748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fe4748",
  null
  
)

export default component.exports